import React, { useEffect, useMemo, useState } from "react";
import { Table, Row, Col, Input, Modal, Form, Label } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import Swal from "sweetalert2";
import NewPagination from "components/Common/Newpagination";
import {
  fetchNodeData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData";
import Loader from "pages/Separate/Loader";
import secureLocalStorage from "react-secure-storage";
import "../../../../assets/css/KnowledgeBase/Index.css";
import "../../../../assets/css/Finance/Style/Inventory/Inventory.css";
import departmentImg from "../../../../assets/images/addTeams.jpg";

const TableContainer = ({
  columns,
  data,
  modalOpen,
  setModalOpen,
  setEditingId,
  setNewLetter,
}) => {
  const [fixedContent, setFixedContent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setFixedContent(window.scrollY > 160);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    { columns, data, initialState: { pageSize: 10 } },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => setPageSize(10), []);

  return (
    <div className="px-2">
      <Row className="mb-2">
        <Col lg={2}>
          <select
            className="form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[10, 20, 30, 40, 50].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-between">
          <div className="me-2">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <input
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  type="text"
                  className="form-control rounded h-100"
                  placeholder="Search..."
                  value={globalFilter || ""}
                  style={{ width: "200px" }}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="">
            <button
              className="btn btn-save btn-label"
              onClick={() => {
                setEditingId(null);
                setNewLetter("");
                setModalOpen(true);
              }}
            >
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Document Type
            </button>
            <button
              onClick={() => navigate(-1)}
              className=" btn ms-md-2 btn-red btn-label"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              CANCEL
            </button>
          </div>
        </Col>
      </Row>

      <Table
        className={`table table-bordered mt-4 ${fixedContent ? "fixed_header" : ""
          }`}
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                // <th key={index} {...column.getHeaderProps()}>
                //   {column.render("Header")}
                // </th>
                <th
                  key={index}
                  {...column.getHeaderProps({
                    style: {
                      width: column.width,
                      minWidth: column.minWidth,
                      maxWidth: column.maxWidth,
                    },
                  })}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr key={i} {...row.getRowProps()}>
                {row.cells.map((cell, index) => (
                  <td key={index} {...cell.getCellProps()}>
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  );
};

const LetterType = () => {
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [newLetter, setNewLetter] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [isLoading, setLoading] = useState();
  const navigate = useNavigate();

  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const fetchNodeData = async () => {
    const response = await fetchNodeData(
      toggleLoading,
      `LetterTypes`,
      secureLocalStorage.getItem("auth_token")
    );
    console.log(`response: `, response);
    if (response.status) {
      setData(response.data);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    fetchNodeData();
  }, []);

  // New function for adding a Letter
  const addLetter = async (LetterName) => {
    toggleLoading(true);
    try {
      const response = await FetchNodePostData(
        toggleLoading,
        `LetterTypes`,
        secureLocalStorage.getItem("auth_token"),
        { LetterName: LetterName }
      );
      console.log("Add response:", response);
      if (response.data.status) {
        await fetchNodeData();
        Swal.fire("Success", "Letter added successfully", "success");
      } else {
        Swal.fire("Error", response.message || "Failed to add Letter", "error");
      }
    } catch (error) {
      console.error("Add error:", error);
      Swal.fire("Error", "An error occurred while adding", "error");
    } finally {
      toggleLoading(false);
    }
  };

  const editLetter = async (id, LetterName) => {
    toggleLoading(true);
    try {
      const response = await FetchNodePutData(
        toggleLoading,
        `LetterTypes`,
        id,
        { LetterName }
      );
      console.log("Edit response:", response);
      if (response.data.status) {
        await fetchNodeData();
        Swal.fire("Success", "Letter updated successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.message || "Failed to update Letter",
          "error"
        );
      }
    } catch (error) {
      console.error("Edit error:", error);
      Swal.fire("Error", "An error occurred while updating", "error");
    } finally {
      toggleLoading(false);
    }
  };

  // New function for deleting a Letter
  const deleteLetter = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        toggleLoading(true);
        try {
          const response = await FetchNodeDeleteData(
            toggleLoading,
            `LetterTypes`,
            id
          );
          console.log("Delete response:", response);
          if (response.data.status) {
            await fetchNodeData(); // Refresh data after delete
            Swal.fire("Deleted!", "Letter has been deleted.", "success");
          } else {
            Swal.fire(
              "Error",
              response.message || "Failed to delete Letter",
              "error"
            );
          }
        } catch (error) {
          console.error("Delete error:", error);
          Swal.fire("Error", "An error occurred while deleting", "error");
        } finally {
          toggleLoading(false);
        }
      }
    });
  };

  const handleAddLetter = async (e) => {
    e.preventDefault();
    if (!newLetter.trim()) return;

    if (editingId) {
      await editLetter(editingId, newLetter.trim(), copy);
    } else {
      await addLetter(newLetter.trim());
    }

    setModalOpen(false);
    setNewLetter("");
    setEditingId(null);
  };

  const handleEdit = (rowData) => {
    setNewLetter(rowData?.LetterName);
    setEditingId(rowData?.id);
    setCopy(rowData?.allow_copy);
    setModalOpen(true);
  };

  const handleDelete = (id) => {
    deleteLetter(id);
  };

  // const handleToggleCopy = async (row) => {
  //   toggleLoading(true);

  //   try {
  //     const updatedCopy = row.allow_copy == 1 ? 0 : 1;

  //     console.log("updatedCopy: ", updatedCopy);
  //     const response = await FetchNodePutData(
  //       toggleLoading,
  //       `copyStatus`,
  //       row.id,
  //       { LetterName: row.LetterName, copy: updatedCopy }
  //     );

  //     console.log(":response: ", response);
  //     if (response.data.success) {
  //       fetchNodeData();
  //       // Swal.fire("Updated!", "Copy switch updated.", "success");
  //     }
  //   } catch (error) {
  //     Swal.fire("Error", "Unable to update copy status.", `${error.message}`);
  //   } finally {
  //     toggleLoading(false);
  //   }
  // };

  const handleToggleCopy = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${row.allow_copy == 1 ? "disable" : "enable"
        } copy for this Letter?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, proceed",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) {
        return; // ❌ User cancelled → Do nothing
      }

      // ✅ User confirmed → Call API
      toggleLoading(true);
      try {
        const updatedCopy = row.allow_copy == 1 ? 0 : 1;

        const response = await FetchNodePutData(
          toggleLoading,
          `copyStatus`,
          row.id,
          { LetterName: row.LetterName, copy: updatedCopy }
        );

        if (response.data.success) {
          fetchNodeData();
          Swal.fire(
            "Updated!",
            `Copy status has been ${updatedCopy ? "enabled" : "disabled"}.`,
            "success"
          );
        }
      } catch (error) {
        Swal.fire("Error", "Unable to update copy status.", `${error.message}`);
      } finally {
        toggleLoading(false);
      }
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: <div style={{ textAlign: "center" }}>ID</div>,
        accessor: "id",
        className: "inv_action",
        width: 20,
        minWidth: 20,
        maxWidth: 20,
        Cell: ({ value }) => <div style={{ textAlign: "center" }}>{value}</div>,
      },
      {
        Header: "Document Type",
        accessor: "LetterName",
      },
      {
        Header: <div style={{ textAlign: "center" }}>Copy Link </div>,
        accessor: "allow_copy",
        width: 20,
        minWidth: 20,
        maxWidth: 20,
        Cell: ({ row }) => (
          <div className="d-flex justify-content-center">
            <div className="form-switch form-switch-md">
              <input
                type="checkbox"
                className="form-check-input"
                checked={row.original.allow_copy == 1}
                onClick={() => handleToggleCopy(row.original)}
              />
            </div>
          </div>
        ),
      },

      {
        Header: () => <div style={{ textAlign: "center" }}>Action</div>,
        accessor: "action",
        className: "inv_action t-col-1",
        width: 40,
        minWidth: 40,
        maxWidth: 40,
        Cell: ({ row }) => (
          <div
            className=" d-flex gap-1"
            style={{ justifyContent: "center", whiteSpace: "nowrap" }}
          >
            <div className="meetToggle">
              {/* <div className="d-flex align-items-center gap-2">
                {/* <label className="mb-0">Copy Link</label> 

                <div className="form-switch form-switch-md">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="myCheckboxs"
                    // onChange={(e) => {
                    //   setCopy(e.target.checked ? 1 : 0);
                    // }}
                    onClick={() => handleToggleCopy(row.original)}
                    checked={row.original.allow_copy == 1}
                  />
                </div>
              </div> */}
            </div>
            <a
              onClick={() => handleEdit(row.original)}
              className="btn btn-sm btn-outline-secondary"
            >
              <i className="fas fa-pencil-alt"></i>
            </a>
            <a
              onClick={() => handleDelete(row.original.id)}
              className="btn btn-sm btn-outline-danger"
            >
              <i className="fas fa-trash-alt"></i>
            </a>
          </div>
        ),
      },
    ],
    [] // Removed [data] dependency since handlers now trigger refresh
  );

  const [copy, setCopy] = useState(0);

  useEffect(() => {
    console.log(copy);
  }, [copy]);

  return (
    <React.Fragment>
      <div className="p-4 bg-white shadow">
        {isLoading && <Loader />}
        <Row>
          <Col lg={4} className="p-0">
            <div className="justify-content-center">
              <img src={departmentImg} className="img-fluid" />
            </div>
          </Col>
          <Col lg={8} className="p-0">
            <div className="responsive-table">
              <TableContainer
                columns={columns}
                data={data}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                setEditingId={setEditingId}
                setNewLetter={setNewLetter}
              />
            </div>
          </Col>
        </Row>

        <Modal isOpen={modalOpen} centered size="sm">
          <div className="modal-header">
            <h5 className="modal-title">
              {editingId ? "Edit" : "Add"} Document Type
            </h5>
            <button
              type="button"
              className="btn-modal-close"
              onClick={() => setModalOpen(false)}
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleAddLetter}>
              <div className="mb-3">
                <Label>
                  Letter Title <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  value={newLetter}
                  onChange={(e) => setNewLetter(e.target.value)}
                  required
                />
              </div>
              {/* <div className="meetToggle">
                <div className="d-flex align-items-center gap-2">
                  <label className="mb-0">Copy Link</label>

                  <div className="form-switch form-switch-md">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="myCheckboxs"
                      onChange={(e) => {
                        setCopy(e.target.checked ? 1 : 0);    
                      }}
                      defaultChecked={copy == 1}
                    />
                  </div>
                </div>
              </div> */}
              <div className="text-end">
                <button type="submit" className="btn btn-purple">
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default LetterType;
